import React, { useState } from "react";
import Signup from "../components/modals/Signup";

export default function Admin() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <div className="user__top">
        <div>
          <button
            className="btn btn__primary"
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            Create user
          </button>
        </div>
      </div>

      {isModalOpen && (
        <Signup isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      )}
    </>
  );
}
